import React from 'react';
import CardBack from './back/content';
import CardFront from './front/content';

export default class PrintableCard extends React.Component {
  render() {
    return (
      <div
        className="flex flex-col gap-3 justify-center items-center"
        style={{ width: '21.5cm', height: '25cm' }}
      >
        <div
          className="bg-white relative border"
          style={{ width: '8.5cm', height: '5.5cm' }}
        >
          <CardFront card={this.props.card} readonly />
        </div>
        <div
          className="bg-white relative overflow-hidden border"
          style={{ width: '8.5cm', height: '5.5cm' }}
        >
          <CardBack card={this.props.card} readonly />
        </div>
      </div>
    );
  }
}
